
(function ($) {
  //////////////////////////////////////////////////////////////////////////////
  //Compare Table
  //////////////////////////////////////////////////////////////////////////////
  //

  // to intitualize this plugin all you have to do is add this to your javascript file:
  $.fn.compareTable = function (options, callback) {
    var settings = $.extend({
      settingsOption: false
    }, options)

    $(this).each(function (e) {
      var theTable = $(this);
      theTable.find('table').before('<div class="compare-section"></div>')
      var compareSection = theTable.find('.compare-section');


      theTable.find('thead a').each(function () {
        var name = $(this).html();
        compareSection.append("<div class='checkbox'><input type='checkbox' name='" + name + "' aria-label='" + name + "' checked='true'><label><div class='icon-utility-close' aria-label='Close' role='img'></div><div class='icon-utility-check' aria-label='check' role='img'></div><span>" + name + "</span></label></div>");
        // compareSection.prepend("<h2 class='nothing-selected'>Please Select a Product</h2>");
      })
      var compareSectionInput = compareSection.find('input');



      compareSectionInput.on('click', function () {
        var name = $(this).attr('name');
        var number = theTable.find('thead a:contains("' + name + '")').parent().index() + 1;

        if (!($(this).prop('checked') && ($(this).attr('name') === name))) {

          theTable.find('thead th:nth-child(' + number + ')').hide();
          theTable.find('tbody tr td:nth-child(' + number + ')').hide();

        } else if (($(this).prop('checked') && ($(this).attr('name') === name))) {
          theTable.find('thead th:nth-child(' + number + ')').show();
          theTable.find('tr td:nth-child(' + number + ')').show();
        }





      })

      compareSection.on('click', function () {
        if (compareSectionInput.not(':checked').length == compareSectionInput.length) {
          theTable.find('table').addClass('hidden');
          theTable.find('.nothing-selected').show();
        } else {
          theTable.find('table').removeClass('hidden');
          theTable.find('.nothing-selected').hide();
        }

      });

      if (compareSectionInput.not(':checked').length == compareSectionInput.length) {
        theTable.find('table').addClass('hidden');
        theTable.find('.nothing-selected').show();
      } else {
        theTable.find('table').removeClass('hidden');
        theTable.find('.nothing-selected').hide();
      }

      compareSectionInput.click(function () {
        $(this).next().next().prop('disabled', !this.checked)


        if (theWindow.width() <= 1200 && theWindow.width() >= 900) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 4);
        } else if (theWindow.width() <= 900 && theWindow.width() >= 600) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 3);
        } else if (theWindow.width() <= 600 && theWindow.width() >= 400) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 2);
        } else if (theWindow.width() <= 400 && theWindow.width() >= 1) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 1);
        } else {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 99);
        }

      });

      theWindow.on('load window:resize', function () {

        if (theWindow.width() <= 1200 && theWindow.width() >= 900) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 4);
        } else if (theWindow.width() <= 900 && theWindow.width() >= 600) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 3);
        } else if (theWindow.width() <= 600 && theWindow.width() >= 340) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 2);
        } else if (theWindow.width() <= 340 && theWindow.width() >= 250) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 1);
        } else if (theWindow.width() > 1200) {
          theTable.find('thead th').show();
          theTable.find('tbody tr td').show();
        } else {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 99);
        }


        var number = compareSection.find('input:checked').last().parent().index() + 2;

        theTable.find('thead th:nth-child(' + number + ')').hide();
        theTable.find('tbody tr td:nth-child(' + number + ')').hide();

        if (theWindow.width() >= 1200) {
          compareSection.find('input').prop("checked", true);
        }

      });

      function uncheckLast(a) {
        if (a.matches) {

          compareSection.find('input:checked').last().prop("checked", false);
          var number = compareSection.find('input:checked').last().parent().index() + 2;

          theTable.find('thead th:nth-child(' + number + ')').hide();
          theTable.find('tbody tr td:nth-child(' + number + ')').hide();


        }
      }


      var width_1200 = window.matchMedia("(max-width: 1200px)")
      var width_900 = window.matchMedia("(max-width: 900px)")
      var width_600 = window.matchMedia("(max-width: 600px)")
      var width_400 = window.matchMedia("(max-width: 400px)")

      uncheckLast(width_1200)
      uncheckLast(width_900)
      uncheckLast(width_600)
      uncheckLast(width_400)


      width_1200.addListener(uncheckLast)
      width_900.addListener(uncheckLast)
      width_600.addListener(uncheckLast)
      width_400.addListener(uncheckLast)


    });
  }

 

 
  $.fn.basictable = function(options) {
    const setup = function(table, data) {
      const headings = [];
      if (data.tableWrap) {
        table.wrap('<div class="bt-wrapper"></div>');
      }
      if (data.header) {
        let format = "";
        if (table.find("thead tr th").length) {
          format = "thead th";
        } else if (table.find("tbody tr th").length) {
          format = "tbody tr th";
        } else if (table.find("th").length) {
          format = "tr:first th";
        } else {
          format = "tr:first td";
        }
        $.each(table.find(format), (function() {
          const $heading = $(this);
          const colspan = parseInt($heading.attr("colspan"), 10) || 1;
          const row = $heading.closest("tr").index();
          if (!headings[row]) {
            headings[row] = [];
          }
          for (let i = 0; i < colspan; i++) {
            headings[row].push($heading);
          }
        }));
      }
      $.each(table.find("tbody tr"), (function() {
        setupRow($(this), headings, data);
      }));
      $.each(table.find("tfoot tr"), (function() {
        setupRow($(this), headings, data);
      }));
    };
    const setupRow = function($row, headings, data) {
      $row.children().each((function() {
        const $cell = $(this);
        if (($cell.html() === "" || $cell.html() === "&nbsp;") && !data.showEmptyCells) {
          $cell.addClass("bt-hide");
        } else {
          const cellIndex = $cell.index();
          let headingText = "";
          for (let j = 0; j < headings.length; j++) {
            if (j !== 0) {
              headingText += ": ";
            }
            const $heading = headings[j][cellIndex];
            headingText += $heading.html();
          }
          $cell.prepend('<span class="bt-content-th">'+headingText+'</span>')
          if (data.contentWrap && !$cell.children().hasClass("bt-content")) {
            
            $cell.wrapInner('<span class="bt-content" />');
          }
        }
      }));
    };
    const unwrap = function(table) {
      $.each(table.find("td"), (function() {
        const $cell = $(this);
        const content = $cell.children(".bt-content").html();
        $cell.html(content);
      }));
    };
    const check = function(table, data) {
      if (!data.forceResponsive) {
        if (table.removeClass("bt").outerWidth() > table.parent().width()) {
          start(table, data);
        } else {
          end(table, data);
        }
      } else {
        if (data.breakpoint !== null && $(window).width() <= data.breakpoint || data.containerBreakpoint !== null && table.parent().width() <= data.containerBreakpoint) {
          start(table, data);
        } else {
          end(table, data);
        }
      }
    };
    const start = function(table, data) {
      table.addClass("bt");
      if (!data.header) {
        table.addClass("bt--no-header");
      }
      if (data.tableWrap) {
        table.parent(".bt-wrapper").addClass("active");
      }
    };
    const end = function(table, data) {
      table.removeClass("bt bt--no-header");
      if (data.tableWrap) {
        table.parent(".bt-wrapper").removeClass("active");
      }
    };
    const destroy = function(table, data) {
      table.removeClass("bt bt--no-header");
      table.find("td").removeAttr("data-th");
      if (data.tableWrap) {
        table.unwrap();
      }
      if (data.contentWrap) {
        unwrap(table);
      }
      table.removeData("basictable");
    };
    const resize = function(table) {
      if (table.data("basictable")) {
        check(table, table.data("basictable"));
      }
    };
    this.each((function() {
      const table = $(this);
      if (table.length === 0 || table.data("basictable")) {
        if (table.data("basictable")) {
          const data = table.data("basictable");
          if (options === "destroy") {
            destroy(table, data);
          } else if (options === "restart") {
            destroy(table, data);
            table.data("basictable", data);
            setup(table, data);
            check(table, data);
          } else if (options === "start") {
            start(table, data);
          } else if (options === "stop") {
            end(table, data);
          } else {
            check(table, data);
          }
        }
        return false;
      }
      const settings = $.extend({}, $.fn.basictable.defaults, options);
      const vars = {
        breakpoint: settings.breakpoint,
        containerBreakpoint: settings.containerBreakpoint,
        contentWrap: settings.contentWrap,
        forceResponsive: settings.forceResponsive,
        noResize: settings.noResize,
        tableWrap: settings.tableWrap,
        showEmptyCells: settings.showEmptyCells,
        header: settings.header
      };
      if (vars.breakpoint === null && vars.containerBreakpoint === null) {
        vars.breakpoint = 568;
      }
      table.data("basictable", vars);
      setup(table, table.data("basictable"));
      if (!vars.noResize) {
        check(table, table.data("basictable"));
        $(window).bind("resize.basictable", (function() {
          resize(table);
        }));
      }
    }));
  };
  $.fn.basictable.defaults = {
    breakpoint: null,
    containerBreakpoint: null,
    contentWrap: true,
    forceResponsive: true,
    noResize: false,
    tableWrap: false,
    showEmptyCells: false,
    header: true
  };
  

  ///////////////////////////////////////////////////////////////////////////
  //Compare Table end                                          
  ///////////////////////////////////////////////////////////////////////////

})(jQuery); // or even jQuery.noConflict()